import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { ContactForm } from '../components/contact-form'
import { ContentContainer } from '../components/content-container'
import { Section } from '../components/section'
import { SectionSpaceMedium } from '../components/section-space'
import { SectionTitle } from '../components/section-title'
import { Title } from '../components/title'
import { useContactPageQuery } from '../generated/graphql'

const Outer = styled.div``

const Inner = styled.div``

type ContactPageProps = {

}
export const ContactPage: FunctionComponent<ContactPageProps> = () => {
  return <Outer>
    <ContentContainer>
      <Section>
        <SectionTitle>会員登録</SectionTitle>
        <SectionSpaceMedium />
        <ContactForm />
      </Section>
    </ContentContainer>
  </Outer>
}